<div class="lightTheme">
  <div class="d-flex flex-row page-header">
    Formula Builder
    <button (click)="openFBDialog()" matTooltip="Add Model" matTooltipPosition="right" class="p-0 btn actionBtn add"></button>
  </div>
  <router-outlet></router-outlet>
</div>